// extracted by mini-css-extract-plugin
export default {"info-message":"_info-message_pOPIUt"};